import { ExperimentPlatformTypes } from '@lyrahealth-inc/shared-app-logic/src/features/experiments/types'

import { IS_CYPRESS_MOBILE, IS_WEB } from '../constants'
import { useGetIsMobileWebBrowser } from './useGetIsMobileWebBrowser'

export const useGetSnsExperimentEventPlatformType = () => {
  const isMobileWebBrowser = useGetIsMobileWebBrowser()
  const platform =
    IS_WEB && !IS_CYPRESS_MOBILE
      ? isMobileWebBrowser
        ? ExperimentPlatformTypes.MOBILE_WEB
        : ExperimentPlatformTypes.DESKTOP_WEB
      : ExperimentPlatformTypes.MOBILE_APP
  return platform
}
